import DeleteIcon from "@mui/icons-material/Delete";
import {
  Autocomplete,
  Button,
  FormControl,
  InputLabel,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import readXlsxFile from "read-excel-file";
import { customFieldsAsync } from "../../../_redux/_services/UserManagerSlice";
import { updateSnackbar } from "../../../_redux/SnackbarSlice";
import { defaultApplicantsData } from "../../../_utilities/defaultfieldsModel";
import { formatFileSize } from "../../../_utilities/utilities";
import Loading from "../../../components/Loader/Loading";

import { GetUserId } from "../../../_utilities/getUserInfo";
export const ApplicantsReadExcelData = (props) => {
  const [uploadFile, setUploadFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [sourced, setSourced] = useState("");
  const [sourceModelValues, setSourceModelValues] = useState([]);
  // const [GetUserId, setUserId] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customFieldsData = useSelector((state) => state.CustomFields.data);

  useEffect(() => {
    async function init() {
      const userId = await GetUserId();
      dispatch(customFieldsAsync(userId));
    }
    init();
  }, []);

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const data = JSON.parse(JSON.stringify(customFieldsData));
      let overrideDefaultPostingFieldsData = data.filter(
        (x) => x.moduleId.toString() === "2" && x.fieldType === "default",
      );
      if (overrideDefaultPostingFieldsData.length > 0) {
        overrideDefaultPostingFieldsData.forEach((list) => {
          if (list.fieldName === "Source") {
            let updatedCustomValues = JSON.parse(list.customValues);
            let modifiedCustomValues = [];
            updatedCustomValues.forEach((list) => {
              if (
                list !== "Cloud Sourcing" &&
                list !== "Employee Portal" &&
                list !== "Vendor Sourcing" &&
                list !== "Job Board Portal"
              ) {
                modifiedCustomValues.push(list);
              }
            });
            setSourceModelValues(modifiedCustomValues);
          }
        });
      }
    }
  }, [customFieldsData]);

  useEffect(() => {
    let defaultPostingModules = defaultApplicantsData.filter(
      (x) => x.moduleId.toString() === "2",
    );
    if (defaultPostingModules.length > 0) {
      defaultPostingModules.forEach((list) => {
        if (list.fieldName === "Source") {
          setSourceModelValues(list.customValues);
        }
      });
    }
  }, []);

  const onChangehandler = (value, type) => {
    if (type === "source") {
      let sourceIndex = sourceModelValues.findIndex((s) => s === value);
      if (sourceIndex !== -1) {
        let obj = { id: sourceIndex + 1, name: value };
        setSourced(obj);
      }
    }
  };

  const fileImgHandler = (event) => {
    event.preventDefault();
    let uploadFile = event.target.files && event.target.files[0];
    if (!uploadFile) {
      return;
    }
    var allowedExtensions = /(\.xls|\.xlsx)$/i;
    if (!allowedExtensions.test(uploadFile.name)) {
      dispatch(
        updateSnackbar({
          type: "error",
          message: "Invalid file format. Please upload Excel file only",
        }),
      );
      return;
    }
    uploadFile["formatSize"] = formatFileSize(uploadFile.size);
    setUploadFile(uploadFile);
    event.target.value = "";
  };

  // const onUploadExcelHandler = () => {
  //   if (uploadFile && sourced !== '') {
  //     setIsLoading(true);
  //     readXlsxFile(uploadFile).then((rows) => {
  //       setIsLoading(false);
  //       const hasInvalidCell = rows.some((row) =>
  //         row.some(
  //           (cell) =>
  //             typeof cell !== 'string' &&
  //             typeof cell !== 'number' &&
  //             typeof cell !== 'undefined' &&
  //             cell !== null
  //         )
  //       );
  //       if (hasInvalidCell) {
  //         dispatch(
  //           updateSnackbar({
  //             type: 'error',
  //             message: 'Only text/string values are allowed in the Excel file.',
  //           })
  //         );
  //         return;
  //       }
  //       navigate('/ats/layout/applicants/create-bulk', {
  //         state: {
  //           excelData: rows,
  //           uploadedFile: uploadFile,
  //           sourced: sourced,
  //         },
  //       });
  //       props.onReceivechildProps(false, 'close');
  //     });
  //   } else {
  //     dispatch(
  //       updateSnackbar({ type: 'error', message: 'All fields are required' })
  //     );
  //   }
  // };
  const onUploadExcelHandler = () => {
    if (uploadFile && sourced !== "") {
      setIsLoading(true);

      readXlsxFile(uploadFile).then((rows) => {
        setIsLoading(false);

        if (!rows || rows.length === 0) {
          dispatch(
            updateSnackbar({ type: "error", message: "Excel file is empty" }),
          );
          return;
        }

        const headers = rows[0]; // first row = header

        let invalidInfo = null; // store first failing row/col

        // scan all rows starting from row 2 (index 1)
        rows.forEach((row, rowIndex) => {
          row.forEach((cell, colIndex) => {
            // allow: string, number, empty cell (null)
            const isValid =
              cell === null ||
              typeof cell === "string" ||
              typeof cell === "number";

            if (!isValid && invalidInfo === null) {
              invalidInfo = {
                row: rowIndex + 1, // +1 for human readable
                col: colIndex + 1,
                header: headers[colIndex] || `Column ${colIndex + 1}`,
                value: cell,
              };
            }
          });
        });

        if (invalidInfo) {
          dispatch(
            updateSnackbar({
              type: "error",
              message: `Invalid data in ${invalidInfo.header} (Row ${invalidInfo.row}, Column ${invalidInfo.col}), Only text/number values allowed.`,
            }),
          );
          return;
        }

        // 🟢 All good → navigate
        navigate("/ats/layout/applicants/create-bulk", {
          state: {
            excelData: rows,
            uploadedFile: uploadFile,
            sourced: sourced,
          },
        });

        props.onReceivechildProps(false, "close");
      });
    } else {
      dispatch(
        updateSnackbar({ type: "error", message: "All fields are required" }),
      );
    }
  };

  return (
    <div className="applicantsupload">
      <div style={{ width: "100%" }}>
        <FormControl fullWidth>
          <InputLabel className="boldSelectlabel" shrink={true}>
            Sourced from *
          </InputLabel>
          {/* <Select
                        value={sourced?.id}
                        name="Sourced From"
                        autoComplete="off"
                        label="Sourced From*&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
                        onChange={(e) => onChangehandler(e, "source")}
                        style={{ width: "100%", height: "3.5rem", borderRadius: "4px" }}
                        className='sourcedfrominput'
                    >
                        {sourceModelValues.map((name, index) => (
                            <MenuItem className="selectOptions" key={name} value={(index + 1).toString()}>
                                {name}
                            </MenuItem>
                        ))}
                    </Select> */}
          <Autocomplete
            id="controlled-demo"
            options={sourceModelValues}
            getOptionLabel={(option) => option ?? ""}
            disableClearable
            onChange={(e, value) => onChangehandler(value, "source")}
            renderInput={(params) => <TextField {...params} />}
          />
        </FormControl>
      </div>
      <div className="Applicantuploadfileicon" style={{ marginTop: "75px" }}>
        <img
          src={process.env.PUBLIC_URL + "/assests/img/uploadBgIcon.svg"}
          alt=""
        />
      </div>
      <Button
        variant="contained"
        component="label"
        className="appuploadresume"
        disabled={uploadFile}
      >
        <span>
          <b style={{ color: "var(--primary-bg-color)" }}>Upload</b>
          <b style={{ color: "#9E9E9E" }}> browse file to upload </b>
        </span>
        <input
          hidden
          type="file"
          id="fileId"
          onChange={(e) => fileImgHandler(e)}
        />
      </Button>
      <p className="docsupporttext">Supported file formats: Excel </p>

      <div style={{ height: "180px", width: "100%" }}>
        {uploadFile && (
          <div className="uploadfiledata">
            <img
              src={process.env.PUBLIC_URL + "/assests/img/excelIcon.svg"}
              alt=""
            />
            <h5>
              {uploadFile.name}
              <p>{uploadFile.formatSize}</p>
            </h5>
            <span className="closeImgbtn" onClick={() => setUploadFile(null)}>
              <DeleteIcon />
            </span>
          </div>
        )}
      </div>

      <div
        style={{
          textAlign: "right",
          marginTop: "8%",
          position: "relative",
          left: "40%",
        }}
      >
        <Button
          type="button"
          variant="contained"
          size="small"
          disabled={!uploadFile}
          className="saveBtn"
          onClick={onUploadExcelHandler}
        >
          Continue
        </Button>
      </div>
      {isLoading === true ? <Loading /> : ""}
    </div>
  );
};
